<template>
	<div>
		<div class="nodea" v-if="data.list.length == 0"><img src="../../../../assets/img/nodata.png" /></div>
		<div class="list_box" v-for="(item, index) in data.list" :key="index" :infinite-scroll-disabled="noMore" v-infinite-scroll="load">
			<div class="two-overflow type_size_22">{{ item.name }}</div>
			<div class="p_flex type_size_16 p_m_t_20">
				<span class="subject_color">{{ item.classLevel.name }}</span>
				<el-divider direction="vertical"></el-divider>
				<span class="subject_yellow">{{ item.subject_def }}</span>
				<el-divider direction="vertical"></el-divider>
				<span>{{ item.teacher_name }}</span>
				<el-divider direction="vertical"></el-divider>
				<span>{{ item.question_count }}道题</span>
			</div>
			<div class="p_flex p_f_a p_f_b p_m_t_20">
				<span>提交时间 {{ item.create_date }} 至 {{ item.submit_date }}</span>
				<div class="p_flex"><el-button @click.stop="goStayAnswer(item)" type="success" size="mini">开始答题</el-button></div>
			</div>
		</div>
		<div class="p_flex p_f_c p_m_t_20 p_m_b_20" v-if="loading">加载中...</div>
		<div class="p_m_l_20 p_m_r_20" v-if="noMore"><el-divider>没有更多了</el-divider></div>
	</div>
</template>

<script>
export default {
	props: {
		i: {
			type: Number,
			default() {
				return 0;
			}
		}
	},
	data() {
		return {
			loading: true,
			noMore: false,
			data: { count: 0, list: [] },
			postData: { limit: 10, page: 1 },
			userInfo: {}
		};
	},
	created() {},

	computed: {},
	mounted() {
		this.getList();
		this.userInfo = JSON.parse(localStorage.getItem('user'));
	},
	methods: {
		getList() {
			this.$request
				.ajax(this)
				.post('/api_student/job_publish_wait_job', this.postData)
				.then(res => {
					var list = res.data.list;
					if (list.length > 0) {
						this.data.list = this.data.list.concat(list);
					} else {
						this.noMore = true;
					}
					this.data.count = res.data.count;
					this.loading = false;
				});
		},

		load() {
			this.postData.page = this.postData.page + 1;
			this.getList();
		},
		goStayAnswer(e) {
			var that = this
			if (e.job_type == 1) {
				that.$request
					.ajax(that)
					.post('api_student/start_answer', { job_publish_id: e.id })
					.then(res => {
						if (res.status == 1) {
							that.$router.push({
								path: '/StayAnswer',
								query: {
									jobPublishId: e.id
								}
							});
						}
					})
					.catch(res => {
						that.$message.error(res.msg)
					});
			} else {
				// 答题卡
				that.$request
					.ajax(that)
					.post('api_student/start_answer', { job_publish_id: e.id })
					.then(res => {
						if (res.status == 1) {
							that.$router.push({
								path: '/AnswerSheets',
								query: {
									jobPublishId: e.id
								}
							});
						}
					})
					.catch(res => {
						that.$message.error(res.msg)
					});
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.list_box {
	padding: 20px 0;
	border-bottom: 1px solid #e6e6e6;
	margin: 0 20px;
}
.type_size_22 {
	line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/components/homes/stay/commponents/indexList.vue